import './Loading.css';
const Loading = () => {
    return (
        <>
        <div className="contain col-12">
        <div className="loadingio-spinner-bars-nm5uxiyfe8m"><div className="ldio-bvnqwyv6add">
        <div></div><div></div><div></div><div></div>
        </div></div>
        </div>

        </>
    )
}
 
export default Loading;